import { ReactNode } from 'react';
import clsx from 'clsx';
import { Button } from '@axo/ui-core/components/Button';
import { Icon } from '@axo/ui-core/components/Icon';
import { Stack } from '@axo/ui-core/components/layout/item';
import styles from './SteppedNumberInput.module.scss';

type TSteppedNumberInputProps = {
  value: number;
  onChange: (newValue: number) => void;
  children?: ReactNode;
  maxValue?: number;
  minValue?: number;
  valueFormatter?: (value: number) => ReactNode;
};

const SteppedNumberInput = ({
  value,
  onChange,
  maxValue,
  minValue = 0,
  valueFormatter,
}: TSteppedNumberInputProps) => {
  const handleIncrement = () => {
    onChange(value + 1);
  };

  const handleDecrement = () => {
    onChange(value - 1);
  };

  const formattedValue = valueFormatter ? valueFormatter(value) : value;

  const isIncrementDisabled = maxValue !== undefined && value >= maxValue;
  const isDecrementDisabled = minValue !== undefined && value <= minValue;

  return (
    <div className={styles.container}>
      {/* TODO: Move Stepper into a separate component */}
      <Stack direction={'h'} className={styles.selector}>
        <Button
          variant={'tertiary'}
          iconOnly
          aria-label="minus"
          size={'m'}
          onClick={handleDecrement}
          className={clsx(
            styles.button,
            isDecrementDisabled && styles.disabled
          )}
          disabled={isDecrementDisabled}
        >
          <Icon name="minus" />
        </Button>
        {formattedValue}
        <Button
          variant={'tertiary'}
          aria-label="plus"
          iconOnly
          size={'m'}
          onClick={handleIncrement}
          className={clsx(
            styles.button,
            isIncrementDisabled && styles.disabled
          )}
          disabled={isIncrementDisabled}
        >
          <Icon name="plus" />
        </Button>
      </Stack>
    </div>
  );
};
export default SteppedNumberInput;
